<template>
  <div style="width: 100%;">
    <h1 class="tw-text-infinity-highlight tw-text-base tw-pb-4 tw-pt-8 tw-uppercase">Transaction Details</h1>
    <table cellspacing="0" class="transaction-details-table tw-text-infinity-primary-text">
      <thead class="table-header tw-bg-infinity-highlight-faded tw-text-infinity-secondary-text">
        <tr class="table-row">
          <th class="table-left-cell">ITEMS</th>
          <th :colspan="colspan" class="table-right-cell">PRICE</th>
        </tr>
      </thead>
      <tbody>
        <tr class="table-row" v-for="item in filteredItems" :key="item.id">
          <td class="table-left-cell">
            <p :style="{maxWidth: cellMaxWidth}" class="tw-truncate table-item-text tw-text-infinity-primary-text tw-text-base">{{ item.name }}</p>
            <p :style="{maxWidth: cellMaxWidth}" class="tw-truncate item-label tw-text-infinity-tertiary-text tw-text-sm">{{ itemLabel(item) }}</p>
          </td>
          <td :colspan="colspan" class="table-right-cell">
            <span v-if="item.initial_price" class="tw-text-infinity-secondary-text" :class="mobile ? 'initial-price-mobile': 'initial-price'">${{ item.initial_price.amount }}</span>
            ${{ item.price.amount}}
          </td>
        </tr>
      </tbody>
      <tfoot class="tw-pb-8">
        <tr v-if="total.subTotal" class="table-row">
          <td class="table-total-cell tw-text-infinity-secondary-text">Subtotal</td>
          <td class="table-total-cell tw-font-medium" :colspan="colspan">${{ total.subTotal }}</td>
        </tr>
        <tr v-if="total.discount" class="table-row">
          <td class="table-total-cell tw-text-infinity-secondary-text">Discount</td>
          <td class="table-total-cell tw-font-medium" :colspan="colspan">${{ total.discount }}</td>
        </tr>
        <tr class="table-row">
          <td class="tw-w-full table-total-cell tw-text-infinity-secondary-text">Total</td>
          <td class="table-total-cell tw-font-medium" :colspan="colspan">${{ total.total }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      type: Array
    },
    total: {
      type: Object
    }
  },
  methods: {
    itemLabel(item) {
      if(item.saleable_type === 'beattapes' || item.saleable_type === 'collection') return `${item.collection_items_count} Beats`
      if(item.saleable_type === 'song' ) return mediaType(item)
      if(item.license_name && this.mediaType(item)) return `${item.license_name} - ${this.mediaType(item)}`
      if(item.license_name) return item.license_name
      return this.mediaType(item)
    },
    mediaType(item) {
      if(!item.saleable_type) return ''
      switch(item.saleable_type) {
        case "beat":
          return "Beat";
        case "soundkit":
          return "Sound Pack";
        case "song":
          return "Song";
        case "service":
          return "Service";
        case "service_quote":
          return "Service Quotation";
        case "collection":
        case "beattapes":
          return "Beat Tapes";
      }
      return ''
    },
  },
  computed: {
    colspan() {
      if(this.mobile) return 1
      return 2
    },
    mobile() {
      return this.$store.state.viewPortWidth <=640;
    },
    cellMaxWidth() {
      const viewPortWidth = this.$store.state.viewPortWidth
      if (viewPortWidth) {
        if (viewPortWidth < 345 || viewPortWidth*0.7 < 345) return 222 + 'px'
        return Math.min(600, viewPortWidth*0.7) + 'px'
      }
      return '222px';
    },
    filteredItems(){
      return this.items.map(item => {
        if(item.initial_price && item.initial_price.amount && item.price.amount !== item.initial_price.amount) return item
        else {
          item.initial_price = null
          return item
        }
      })
    }
  }
}
</script>
<style>
.transaction-details-table {
  width:100%;
}
.table-header {
  text-align: left;
  border-bottom: 0.75px solid #F6F0F9;
  padding: 12px;
}

.table-left-cell,.table-right-cell {

  border-bottom: 0.75px solid #F6F0F9;
  padding: 12px;
  white-space: nowrap;
  padding:1rem;
}
.table-total-cell {
  padding: 12px;
  white-space: nowrap;
  padding:0.75rem 1rem;
  text-align: right;
}
.table-left-cell {
  text-align: left;
}
.table-right-cell {
  text-align: right;
  width:100%;
}
.item-label {
  margin-top: 10px;
  font-weight: 400;
  margin:0;
}
.table-item-text {
  font-weight: 500;
  margin:0;
}
.table-item-text-mobile {
  max-width: 190px;
}
.initial-price {
  margin-right: 10px;
  text-decoration: line-through;
}
.initial-price-mobile {
  margin-right: 0;
  text-decoration: line-through;
  display: block;
}

</style>
